import { h, Fragment } from "preact";
import React from "react";
import { Card, Switch, Button, Tooltip } from "antd";
import {
    VerticalAlignTopOutlined,
    VerticalAlignBottomOutlined,
    HolderOutlined,
    InfoCircleOutlined,
} from "@ant-design/icons";

export const ServiceCard = ({
                                service,
                                moveService,
                                toggleService,
                                renderCardContent,
                                provided,
                                services,
                                index,
                                activeServiceNumber,
                                movingServiceId,
                                direction,
                            }) => {
    return (
        <Card
            key={service.id}
            style={{ marginBottom: 8, background: "#f0f2f5" }}
            className={`flow-service-card ${
                movingServiceId === service.id
                    ? direction === "up"
                        ? "move-up"
                        : "move-down"
                    : ""
            }`}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}
                >
                    {service.isActive && activeServiceNumber && (
                        <div
                            style={{
                                display: "flex",
                                width: "30px",
                                height: "30px",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "50%",
                                background: "#507ffb",
                                color: "white",
                                flexShrink: 0,
                            }}
                        >
                            {activeServiceNumber}
                        </div>
                    )}
                    <p style={{ paddingLeft: "20px", margin: 0 }}>{service.name}</p>
                    {service.description && (
                        <Tooltip
                            placement="rightTop"
                            overlayStyle={{ maxWidth: "500px" }}
                            title={service?.description}
                        >
                            <InfoCircleOutlined style={{ marginLeft: "15px" }} />
                        </Tooltip>
                    )}
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Tooltip
                        mouseEnterDelay={1}
                        placement="top"
                        overlayStyle={{ maxWidth: "500px" }}
                        title="You can activate or disable service by toggling this switch button"
                    >
                        <Switch
                            checked={service.isActive}
                            value={service.isActive}
                            onChange={() => toggleService(service.id)}
                        />
                    </Tooltip>

                    {service.paramName !== "consent" && (
                        <>
                            <Tooltip
                                mouseEnterDelay={1}
                                placement="top"
                                overlayStyle={{ maxWidth: "500px" }}
                                title="Move the service above to reorder the items"
                            >
                                <Button
                                    onClick={() => moveService(service.id, "up")}
                                    disabled={
                                        index === 0 || services[index - 1].paramName === "consent"
                                    }
                                    style={{ marginLeft: 8 }}
                                >
                                    <VerticalAlignTopOutlined />
                                </Button>
                            </Tooltip>
                            <Tooltip
                                mouseEnterDelay={1}
                                placement="top"
                                overlayStyle={{ maxWidth: "500px" }}
                                title="Move the service below to reorder the items"
                            >
                                <Button
                                    onClick={() => moveService(service.id, "down")}
                                    disabled={index === services.length - 1}
                                    style={{ marginLeft: 8 }}
                                >
                                    <VerticalAlignBottomOutlined />
                                </Button>
                            </Tooltip>
                            <div {...provided.dragHandleProps}>
                                <Tooltip
                                    mouseEnterDelay={1}
                                    placement="top"
                                    overlayStyle={{ maxWidth: "500px" }}
                                    title="Rearrange the list by dragging and dropping items"
                                >
                                    <HolderOutlined
                                        style={{
                                            fontSize: "25px",
                                            marginLeft: "10px",
                                        }}
                                    />
                                </Tooltip>
                            </div>
                        </>
                    )}
                </div>
            </div>
            {service.isActive && (
                <div style={{ marginTop: "10px" }}>
                    {service.description && <p>{service.description}</p>}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {service.params.length > 0 && renderCardContent(service)}
                    </div>
                </div>
            )}
        </Card>
    );
};
